import React from "react";
import useSearchUserList from "./SearchUserList.hook";
import UserTable from "./UserTable";

function SearchUserList({ selectedUserType, searchedQuery, onUserSelect }) {
  const {
    models: { data, loading, offset, totalPageCount },
    operations: { onPageChange },
  } = useSearchUserList(selectedUserType, searchedQuery);

  return (
    <UserTable
      data={data}
      loading={loading}
      offset={offset}
      totalPageCount={totalPageCount}
      onPageChange={onPageChange}
      onUserSelect={onUserSelect}
    />
  );
}

export default SearchUserList;
